import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Supported languages
const LANGUAGES = {
  en: { code: 'en', name: 'English', flag: '🇬🇧' },
  vi: { code: 'vi', name: 'Tiếng Việt', flag: '🇻🇳' },
  pl: { code: 'pl', name: 'Polski', flag: '🇵🇱' }
};

const DEFAULT_LANGUAGE = 'en';

/**
 * LocalizedRouter component handles language-based URL routing
 * - Redirects root path to default language
 * - Detects and handles invalid language codes
 * - Preserves query parameters and hash during redirects
 */
const LocalizedRouter = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const firstSegment = pathSegments[0];

    // Handle root path - redirect to default language
    if (location.pathname === '/') {
      const savedLang = localStorage.getItem('language') || DEFAULT_LANGUAGE;
      navigate(`/${savedLang}/`, { replace: true });
      return;
    }

    // Check if first segment is a language code
    if (firstSegment && firstSegment.length === 2) {
      // If it's an invalid language code, redirect to English
      if (!LANGUAGES[firstSegment]) {
        console.warn(`Invalid language code: ${firstSegment}, redirecting to English`);
        const pathWithoutLang = '/' + pathSegments.slice(1).join('/');
        navigate(
          `/${DEFAULT_LANGUAGE}${pathWithoutLang}${location.search}${location.hash}`,
          { replace: true }
        );
      }
    }
  }, [location, navigate]);

  return <>{children}</>;
};

export default LocalizedRouter;
